import moment from "moment";

export const appointsList  = [
  {
    "id": 1,
    "p_p": "+79242001545",
    "r_f_n_a_b": "333 s.w.",
    "c_d": "2023-07-26 10:19:11",
    "d_t_s": moment().set({hour: '8', minute: '20'}).format(),
    "dur": "40",
    "cmt": "",
    "rsr": 1,
    "cab": 86,
    "pat": 45566,
    "sts": 1,
    "r_r": null,
    "own": 241,
    "srs": 39,
    "a_t": null,
    "s_t": null,
    "a_o": null,
    "p_c": "43",
    "dbt": 0,
    "p_s_n": "Алексеев",
    "p_f_n": "Михаил",
    "p_p_n": "Юрьевич",
    "p_b_d": moment().add(1, 'day').format('YYYY-MM-DD'),
    "p_g": "M",
    "s_t_sys_name": null,
    "a_t_sys_name": '',
    "sts_sys_name": "new"
  },
  {
    "id": 2,
    "p_p": "+79625551415",
    "r_f_n_a_b": "333 s.w.",
    "c_d": "2023-07-28 12:15:15",
    "d_t_s":  moment().set({hour: '9', minute: '0'}),
    "dur": "45",
    "cmt": "",
    "rsr": 1,
    "cab": 105,
    "pat": 45566,
    "sts": 1,
    "r_r": null,
    "own": 241,
    "srs": 38,
    "a_t": null,
    "s_t": null,
    "a_o": null,
    "p_c": "43",
    "dbt": 0,
    "p_s_n": "Петров",
    "p_f_n": "Василий",
    "p_p_n": "Владимирович",
    "p_b_d": "2000-12-24",
    "p_g": "M",
    "s_t_sys_name": null,
    "a_t_sys_name": 'tatu',
    "sts_sys_name": "new"
  },
  {
    "id": 3,
    "p_p": "+74951201122",
    "r_f_n_a_b": "333 s.w.",
    "c_d": "2023-07-28 12:48:08",
    "d_t_s":  moment().add(1, 'day').set({hour: '16', minute: '40'}),
    "dur": "15",
    "cmt": "",
    "rsr": 1,
    "cab": 87,
    "pat": 45574,
    "sts": 1,
    "r_r": null,
    "own": 241,
    "srs": 38,
    "a_t": null,
    "s_t": null,
    "a_o": null,
    "p_c": "44",
    "dbt": 0,
    "p_s_n": "Иванов",
    "p_f_n": "Иван",
    "p_p_n": "Владимирович",
    "p_b_d": "1995-02-15",
    "p_g": "M",
    "s_t_sys_name": null,
    "a_t_sys_name": null,
    "sts_sys_name": "new"
  },
  {
    "id": 4,
    "p_p": "+79242001545",
    "r_f_n_a_b": "333 s.w.",
    "c_d": "2023-07-26 10:19:11",
    "d_t_s": moment().add(1, 'day').set({hour: '12', minute: '15'}),
    "dur": "40",
    "cmt": "",
    "rsr": 1,
    "cab": 86,
    "pat": 45566,
    "sts": 1,
    "r_r": null,
    "own": 241,
    "srs": 39,
    "a_t": null,
    "s_t": null,
    "a_o": null,
    "p_c": "45",
    "dbt": 0,
    "p_s_n": "Иванов ",
    "p_f_n": "Иван",
    "p_p_n": "Иванович",
    "p_b_d": moment().add(2, 'day').format('YYYY-MM-DD'),
    "p_g": "M",
    "s_t_sys_name": null,
    "a_t_sys_name": null,
    "sts_sys_name": "new"
  },
  {
    "id": 5,
    "p_p": "+74951201122",
    "r_f_n_a_b": "333 s.w.",
    "c_d": "2023-07-28 12:48:08",
    "d_t_s":  moment().add(2, 'day').set({hour: '08', minute: '20'}).format(),
    "dur": "25",
    "cmt": "",
    "rsr": 1,
    "cab": 14,
    "pat": 45574,
    "sts": 1,
    "r_r": null,
    "own": 241,
    "srs": 38,
    "a_t": null,
    "s_t": null,
    "a_o": null,
    "p_c": "None",
    "dbt": 0,
    "p_s_n": "Иванов",
    "p_f_n": "Иван",
    "p_p_n": "Владимирович",
    "p_b_d": "1995-02-15",
    "p_g": "M",
    "s_t_sys_name": null,
    "a_t_sys_name": 'mdo',
    "sts_sys_name": "new"
  },
  {
    "id": 6,
    "p_p": "+74951201122",
    "r_f_n_a_b": "333 s.w.",
    "c_d": "2023-07-28 12:48:08",
    "d_t_s":  moment().add(4, 'day').set({hour: '08', minute: '45'}),
    "dur": "15",
    "cmt": "",
    "rsr": 1,
    "cab": 87,
    "pat": 45574,
    "sts": 2,
    "r_r": null,
    "own": 241,
    "srs": 38,
    "a_t": null,
    "s_t": null,
    "a_o": null,
    "p_c": "None",
    "dbt": 0,
    "p_s_n": "Иванов",
    "p_f_n": "Иван",
    "p_p_n": "Владимирович",
    "p_b_d": "1995-02-15",
    "p_g": "M",
    "s_t_sys_name": null,
    "a_t_sys_name": null,
    "sts_sys_name": "new"
  },
  {
    "id": 7,
    "p_p": "+74951201122",
    "r_f_n_a_b": "333 s.w.",
    "c_d": "2023-07-28 12:48:08",
    "d_t_s":  moment().add(4, 'day').set({hour: '9', minute: '0'}),
    "dur": "40",
    "cmt": "",
    "rsr": 1,
    "cab": 87,
    "pat": 45574,
    "sts": 2,
    "r_r": null,
    "own": 241,
    "srs": 38,
    "a_t": null,
    "s_t": null,
    "a_o": null,
    "p_c": "None",
    "dbt": 0,
    "p_s_n": "Иванов",
    "p_f_n": "Иван",
    "p_p_n": "Владимирович",
    "p_b_d": moment().add(4, 'day').format('YYYY-MM-DD'),
    "p_g": "M",
    "s_t_sys_name": null,
    "a_t_sys_name": null,
    "sts_sys_name": "came"
  },
]